/** Module to check elkjop environment
 * Check if environment is for sellers or for end users
 *
 * This is a singleton class
 */
import { CrulesAPI, NextApiClient, ProjectsAPI } from '@3cad/nextcore'
import { Rule } from '@3cad/nextcore'

export class EDBasketData {

    /**
     * @param prj
     * @param skipQA
     * @return Promise<any>
     */
    static async convertPrj(prj, skipQA) {
        return new Promise( (resolve, reject) => {
            let EDData = prj.getJson();

            EDData.shopemail = prj.shopemail
            EDData.sellerfirstname = prj.sellerfirstname
            EDData.sellerlastname = prj.sellerlastname
            EDData.sellercensoredlastname = prj.sellercensoredlastname
            EDData.sellerfullname = `${prj.sellerfirstname} ${prj.sellercensoredlastname}`

            EDData.history = undefined;
            EDData.envWall = undefined;
            EDData.tops = undefined;
            EDData.jobs = undefined;
            EDData.eval3dtops = undefined;
            EDData.eval3dwall = undefined;
            EDData.boxTops = undefined;
            EDData.measures = undefined;
            EDData.changed = undefined;
            EDData.isopen = undefined;
            EDData.delivery = undefined;
            EDData.nuovo = undefined;
            EDData.versionName = EDData.currentVersion;
            EDData.versionNumber = !!EDData.versionNumber ? EDData.versionNumber : 1;
            EDData.currentVersion = undefined;
            EDData.engine_views = undefined;
            EDData.rows.forEach( r => {
                r.eval3dris = undefined;
                r.job = undefined;
                r.extraEval = undefined;
                r.id = undefined;
                r.catalog = undefined;
                r.model = undefined;
                r.modeldes = undefined;
                r.neutro = undefined;
                r.item = undefined;
                r.cModel = undefined;
                r.cmodel = undefined;
                r.reg = undefined;
                r.cod = undefined;
                r.auto = undefined;
                r.local = undefined;
                r.wallItem = undefined;
                r.l = undefined;
                r.a = undefined;
                r.p = undefined;
                r.pl = undefined;
                r.pa = undefined;
                r.pp = undefined;
                r.nl = undefined;
                r.na = undefined;
                r.np = undefined;
                r.axy = undefined;
                r.axz = undefined;
                r.ayz = undefined;
                r.ul = undefined;
                r.ua = undefined;
                r.up = undefined;
                r.skipBasket = undefined;
                r.jeval3ddone = undefined;
                r.img = undefined;
                r.des = undefined;
                r.boxid = undefined;
                r._configure = undefined;
                r.side = undefined;
                r.vheader = undefined;
                r.load = undefined;
                r.primoCaricamento = undefined;
                r.isloaditem = undefined;
                r.placer = undefined;
                r.classicPlacer = undefined;
                r.parent = undefined;
                r.father = undefined;
                r.clPlacerChilds = undefined;
                r.firstTime = undefined;
                r.altezze = undefined;
                r.rule = undefined;

                r.extra = r.uniqueid >= 3000;

                r.erp.forEach( e => {
                    e.bom = undefined;
                    e.des = undefined;
                    e.gnt = undefined;
                    // e.var = undefined;
                    e.desTrad = undefined;
                    e.tipo4 = undefined;
                    e.punit = undefined;
                    e.sctot = undefined;
                    e.mat = undefined;
                    e.camp = undefined;
                    e.taxes = undefined;

                    e.bop.forEach( b => {
                        b.var = undefined;
                        b.package = undefined;
                        b.l = undefined;
                        b.a = undefined;
                        b.p = undefined;
                        b.volume = undefined;
                        b.peso = undefined;
                        b.derivedRow = undefined;
                    })
                })

                r.erp = r.erp.filter( e => {
                    return e.visible
                })
            });

            EDData.rows = EDData.rows.filter( r => { return r.erp.length > 0 });
            EDData.skipQA = (skipQA === 1);
            EDData.timeStamp = new Date().toISOString();

            let history = prj.getLastHistoryEntry()

            CrulesAPI.initApplica(history.catalog, history.currentModel.cmodel, history.currentModel.header.replace(/;/g, '\t'), res => {
                let rule = new Rule(res.data);

                EDData.NGRHeaderVariants = {}

                rule.rows.forEach( v => {
                    // EDData.NGRHeaderVariants[v.des.replaceAll(' ', '_')] = v.valuedes
                    EDData.NGRHeaderVariants[v.cod] = v.valuedes
                    // EDData.NGRHeaderVariants[v.destrad] = v.valuedes
                })

                if(EDData.b2bHeaderC && !EDData.b2bHeaderC.isDetached) {
                    EDData.versionName = EDData.b2bHeaderC.des

                    // TODO: Check if this exception must be added with DETACHED childs as well
                    EDData.orderaddress[0] = EDData.b2bHeaderC.orderaddress;
                    EDData.shippingaddress[0] = EDData.b2bHeaderC.shippingaddress;

                    let params = { email: EDData.b2bHeaderC.orderaddress.email, chainid: EDData.chainid };
                    ProjectsAPI.guestCheck(params, res => {
                        if(res && res.extra && (res.extra.indexOf('System.Collections.Generic') > -1 || res.extra.indexOf('DicTree') > -1)){
                            res.extra = '';
                        }
                        EDData.customerID = res.extra;
                        NextApiClient.com("e_promos", "jGetCatPromos", { Catalogo: 'EPOQ', orderdate: '' }, erpjson => {
                            console.log('Find campaign', erpjson);
                            if(erpjson.campaign && erpjson.campaign.length > 0) {
                                let campaings = erpjson.campaign;
                                let camp = campaings.find( c => {
                                    return c.cod === EDData.campaign;
                                })

                                if(camp && camp.des)
                                    EDData.campaignDes = camp.des
                                else
                                    EDData.campaignDes = '';

                                resolve(EDData);
                            } else {
                                reject(new TypeError('Campaign code does not match'))
                            }
                        }, reject)
                    }, reject);
                }
                else {
                    let params = { email: EDData.customercod, chainid: EDData.chainid };
                    ProjectsAPI.guestCheck(params, res => {
                        if(res && res.extra && (res.extra.indexOf('System.Collections.Generic') > -1 || res.extra.indexOf('DicTree') > -1)){
                            res.extra = '';
                        }
                        EDData.customerID = res.extra;
                        NextApiClient.com("e_promos", "jGetCatPromos", { Catalogo: 'EPOQ', orderdate: '' }, erpjson => {
                            console.log('Find campaign', erpjson);
                            if(erpjson.campaign && erpjson.campaign.length > 0) {
                                let campaings = erpjson.campaign;
                                let camp = campaings.find( c => {
                                    return c.cod === EDData.campaign;
                                })

                                if(camp && camp.des)
                                    EDData.campaignDes = camp.des
                                else
                                    EDData.campaignDes = '';

                                resolve(EDData);
                            } else {
                                reject(new TypeError('Campaign code does not match'))
                            }
                        }, reject)
                    }, reject);
                }
            }, err => {
                console.error(err)
                throw err
            });

        })
    }

    static filteredData(EDBasketData, items, wItems) {
        /* items and wItems are the same object
        {
      "mainArticle": "015BD1060070B",
      "des": "Dishwasher 60 Integrated",
      "qt": 1,
      "rowId": 0,
      "include": true
    },
    {
      "rowId": 0,
      "mainArticle": "015BD1060070B",
      "subArticle": "015BD1060070B",
      "des": "Dishwasher 60 Integrated",
      "qt": 1,
      "include": true
    },
         */
        // I have to filter rows of EDBasketData.rows and remove bop that are not in items or wItems
        const rows = EDBasketData.rows.filter( r => {
            return items.filter(x => x.subArticle && x.include).find( i => {
                let findErp = i.mainArticle === r.erp[0].cod
                if(findErp) {
                    findErp = findErp && r.erp[0].bop.find( b => {
                        return b.cod === i.subArticle
                    });
                }
                return findErp
            }) || wItems.filter(x => x.subArticle && x.include).find( i => {
                let findErp = i.mainArticle === r.erp[0].cod
                if(findErp) {
                    findErp = findErp && r.erp[0].bop.find( b => {
                        return b.cod === i.subArticle
                    });
                }
                return findErp
            })
        });
        rows.forEach( r => {
            r.erp.forEach( e => {
                e.bop = e.bop.filter( b => {
                   return items.find( i => {
                       return i.include && i.mainArticle === e.cod && i.subArticle === b.cod
                   }) || wItems.find( i => {
                       return i.include && i.mainArticle === e.cod && i.subArticle === b.cod
                   })
                })
            });
        })

        return {
            ...EDBasketData,
            rows
        }
    }
}



// WEBPACK FOOTER //
// ./src/custom/epoq/_modules/EDBasketData.js